import type { FaireProductEntity } from "../../entity_types/product";

export const p_dpj5vz3ueg: FaireProductEntity = {
  token: "p_dpj5vz3ueg",
  type: "product",
  name: "Destination Arkansas Cutting Board with Engraved Artwork",
  brandToken: "b_2ni2ewzx8l",
  brandName: "Totally Bamboo",
  imageUrl:
    "https://cdn.faire.com/fastly/c1e1c1fdfe4ff1dd6d7d2abc0da4cd38389827fb3bdb1acfa9f4e546fe4ed387.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e1704489675b62141b4b19c612bb5aa3b781d260abb6505a42a4c656e2caa9a6.jpeg",
    "https://cdn.faire.com/fastly/ecd562353cffa86a81c60fa8377c29a0fb55b47c639cf5659be020aefb35b563.jpeg",
    "https://cdn.faire.com/fastly/4ad2e44ca176d5571e1536b8ef3e0b767721585ff23aeef1ef059c195f270a2e.jpeg",
    "https://cdn.faire.com/fastly/8950c345dcb82b92ceeaff45a0371c64177ec06cc3a58515b14c7e08bb414627.jpeg",
    "https://cdn.faire.com/fastly/445f0e26e802f7472655107e27175287b817d862a8a1713934480615cc3e41be.jpeg",
  ],
  priceDollars: 15,
  description:
    "Celebrate Arkansas with this beautifully crafted bamboo cutting board! Shaped like The Natural State, it features laser-engraved artwork highlighting the iconic towns, landmarks, and sights that define Arkansas. Shoppers love using it as a fun, conversation-starting charcuterie board for serving crackers, cheese, meat, fruit, candy, and other favorite snacks.\n\nThe blank reverse side offers all the benefits of a bamboo cutting board: a durable, lightweight, and knife-friendly cutting surface. Cut on the back and serve on the front to minimize clean up!\n\nWhen not in use, the included hang tie easily transforms the cheese board into eye-catching home decor.",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:37.832Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
